import {ChromePicker} from 'react-color';
import {Popover} from 'antd';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import styles from './colorPicker.module.scss';

const ColorPicker = ({value, allowClear, isReadOnly, size = 20, onChange, ...props}) => {
  const handleChange = (color) => {
    onChange(color ? color.hex : null);
  };

  const colorPicker = (
    <ChromePicker color={value || '#FFFFFF'} onChangeComplete={handleChange} disableAlpha {...props}/>);
  const colorNotSet = (
    <div className={styles.mask}>
      <div className={styles.colorNotSet} style={{width: size, height: size}}/>
    </div>
  );

  const colorSwatch = (
    <div
      className={styles.colorSwatch}
      style={{
        cursor: isReadOnly ? 'auto' : 'pointer',
        background: value,
        width: size,
        height: size,
      }}
    >
      {!value ? colorNotSet : null}
    </div>
  );

  return (
    <div className={styles.colorPickerWrapper}>
      {!isReadOnly
        ? (
          <Popover content={colorPicker} trigger="click" overlayClassName={styles.popover}>
            {colorSwatch}
          </Popover>
        )
        : colorSwatch}
      {isReadOnly ? null : <span className={styles.colorSwatchMargin}>{value || '-'}</span>}
      {value && !isReadOnly && allowClear
        ? (
          <FontAwesomeIcon
            className={styles.closeIcon}
            icon={faTimes}
            onClick={() => handleChange(null)}
          />
        )
        : null}
    </div>
  );
};

export default ColorPicker;
